<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'order',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    watch: {},
    filters: {},
    computed: {},
    components: {}
}
</script>